import { useState, useEffect } from 'react';
import Protocol from './ProtocolComponent';
import Urls from '../../../utils/urls';

import apiBackendInstance from '../../../utils/axios';

interface ProtocolInterface {
    protocol_name: string,
    network_count: number|string,
}

const ProtocolsDistribution = () => {
  const [protocolsData, setProtocolsData] = useState([] as ProtocolInterface[]);
  useEffect(() => {
    let isActive = true;
    apiBackendInstance.get(Urls.getProtocolWiseDistribution(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response && response.data && response.data.data) {
        setProtocolsData(response.data.data);
      }
    }).catch(() => setProtocolsData([]));
    return () => { isActive = false; };
  }, []);

  return (
        <div className="card CardHeight">
          <h4 className="text-center mt-3">Protocol Wise Distribution</h4>
            <div className="card-body my-2 text-center protocolCard">
                {protocolsData.length === 0
                    && <h6 className="text-center cloudHeading"> Not Enough Data</h6>}
                {
                    protocolsData.map((o, idx) => (
                     <Protocol
                      // eslint-disable-next-line react/no-array-index-key
                      key={idx.toString()}
                       icon={o.protocol_name}
                        name={o.protocol_name}
                        distCount={parseInt(o.network_count.toString(), 10)}
                        totalCount={protocolsData.map((v) => parseInt(v.network_count.toString(), 10)).reduce((p, c) => (parseInt(p.toString(), 10) + parseInt(c.toString(), 10)))}
                     />
                    ))
                }
            </div>
        </div>
  );
};
export default ProtocolsDistribution;
